import React, { type FC, SetStateAction } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSearchParams } from 'react-router-dom';
import { getRequest } from '../../../../Helper/ApiClient';
import { onlineshopApiBaseUrl } from '../../FilterList/Filters/Filters';
import { useProductsFilter } from '../../../../Context/ProductsFilterContext';

const filterTarget = [
  'category_ids',
  'sub_category_ids',
  'sale_percent',
  'sale_type',
  'has_stock',
  'brand_ids',
  'product_ids',
  'product_size_ids',
  'product_attribute_ids',
  'q',
  'favs_only',
];

type ResultCountPropsT = {
  setResultCount: React.Dispatch<SetStateAction<number | undefined>>;
  additionalFilters?: { key: string; value: string }[];
};

const ResultCount: FC<ResultCountPropsT> = ({
  setResultCount,
  additionalFilters,
}) => {
  const { filters } = useProductsFilter();
  const [searchParams] = useSearchParams();
  const queryFilterString = new URLSearchParams();

  filterTarget.map((filterKey) => {
    const val = searchParams.get(filterKey);
    if (val) queryFilterString.set(filterKey, val);
  });

  additionalFilters?.map((filterKey) => {
    queryFilterString.append(filterKey.key, filterKey.value);
  });

  const countTargetSegment = filters.view === 'grid' ? 'sizes' : 'attributes';

  const countRequest = getRequest(
    `${onlineshopApiBaseUrl}/product-${countTargetSegment}/count?${queryFilterString.toString()}`,
    [
      'product_sizes_count',
      'product_attributes_count',
      queryFilterString.toString(),
      countTargetSegment,
    ],
    { onSuccess: (data) => setResultCount(data) }
  );

  if (countRequest.isPending || countRequest.isFetching)
    return <Skeleton height="1em" width={'25px'} />;

  if (!countRequest.data) return <span>0</span>;

  if (countRequest.data) return <span>{countRequest.data}</span>;
};

export default ResultCount;
